import { DateTime } from "luxon";
import { ContentfulItem } from "@/types/entities";
import { normalizeDateTime } from "@/helpers/dateTimeUtilities";

export function sortContentItemsInPlace< T extends ContentfulItem >( items: T[] ): T[] {
    items.sort( ( c1: ContentfulItem, c2: ContentfulItem ): number => {
        const firstArticlePublishDateTime: DateTime = normalizeDateTime( c1.publishedDate );
        const secondArticlePublishDateTime: DateTime = normalizeDateTime( c2.publishedDate );

        if ( !firstArticlePublishDateTime.isValid ) {
            if ( !secondArticlePublishDateTime.isValid ) {
                return 0;
            }

            return -1;
        } else if ( !secondArticlePublishDateTime.isValid ) {
            return 1;
        }

        return firstArticlePublishDateTime.toMillis() < secondArticlePublishDateTime.toMillis() ? 1 : -1;
    } );

    return items;
}
